import { useFormContext } from './utils/useFormContext.js';

// TODO
// Since strong typing is not possible with generics across context, this register
// function will have weaker TypeScript/autocomplete than the useForm register.
// We may want to consider logging a warning or throwing a runtime error if something
// goes wrong to compensate for this gap.

function useFormField() {
  const {
    register,
    formState
  } = useFormContext();

  // const { values, touched, errors, formError, isSubmitting } = formState;

  return {
    register,
    formValues: formState === null || formState === void 0 ? void 0 : formState.values,
    formTouched: formState === null || formState === void 0 ? void 0 : formState.touched,
    fieldErrors: formState === null || formState === void 0 ? void 0 : formState.errors
  };
}

export { useFormField as default };
